// models
import { Base } from 'app/shared/models/base.model';
import { Supplier } from 'app/shared/models/supplier.model';
import { CustomerSector } from 'app/shared/models/customer-sector.model';
import { OrderService } from 'app/shared/models/order-service.model';
import { ContactCustomer } from 'app/shared/models/contact-customer.model';
import { CalibrationType } from 'app/calibrations/shared/calibration-type.model';
import { Instrument } from 'app/instruments/shared/instrument.model';

export class Calibration extends Base {

  constructor(
    public ApproveContact?: ContactCustomer,
    public CalibrationType?: CalibrationType,
    public Code?: string,
    public CustomerApproveDate?: Date,
    public CustomerSector?: CustomerSector,
    public CustomerStatus?: EApproveCalibration,
    public CustomerStatusDescription?: string,
    public Date?: Date,
    public FullBandsDescription?: string,
    public HasAttachment?: Boolean,
    public Instrument?: Instrument,
    public IsField?: boolean,
    public OrderService?: OrderService,
    public ShortBandsDescription?: string,
    public CalibrationStatus?: EApproveCalibration,
    public Status?: ECalibrationStatus,
    public Supplier?: Supplier,
    public TableName?: string,
    public Tag?: string,
    public Comments?: string
  ) {
    super();
  }
}

export enum ECalibrationStatus {
  WaitingValidation = 0,
  Approved = 1,
  Disapproved = 2,
  InProgress = 3,
  None = 4,
  CalculateResults = 5
}

export enum EApproveCalibration {
  None = 0,
  Approved = 1,
  Disapproved = 2,
  ApprovedResave = 3
}



// WEBPACK FOOTER //
// ./src/app/calibrations/shared/calibration.model.ts